import {
    initialModalManagerContext,
    MODAL_PRIORITY,
    ModalId,
    ModalManagerContext,
    modalsToDisplay,
} from "@/Contexts/ModalManagerContext";
import { PropsWithChildren, useState } from "react";

export const ModalManagerProvider = ({ children }: PropsWithChildren) => {
    const [modalToDisplay, setModalToDisplay] = useState<ModalId | null>(
        initialModalManagerContext.modalToDisplay,
    );

    const calculateModalToDisplay = () => {
        if (modalsToDisplay.size === 0) {
            return null;
        }
        return Array.from(modalsToDisplay).sort((a, b) => {
            return MODAL_PRIORITY[b] - MODAL_PRIORITY[a];
        })[0];
    };

    const askToDisplayModal = (modalId: ModalId) => {
        modalsToDisplay.add(modalId);
        setModalToDisplay(calculateModalToDisplay());
    };

    const removeModalFromDisplay = (modalId: ModalId) => {
        modalsToDisplay.delete(modalId);
        setModalToDisplay(calculateModalToDisplay());
    };

    return (
        <ModalManagerContext.Provider
            value={{
                isInModalManagerContext: true,
                modalToDisplay,
                askToDisplayModal,
                removeModalFromDisplay,
            }}
        >
            {children}
        </ModalManagerContext.Provider>
    );
};
